import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      nav: {
        dashboard: 'Dashboard',
        club: 'My Club',
        market: 'Transfer Market',
        matches: 'Matches',
        championship: 'Championship',
        admin: 'Admin Panel',
        superAdmin: 'Super Admin',
        profile: 'Profile',
        logout: 'Logout',
        login: 'Login',
        register: 'Register',
      },
      // Landing
      landing: {
        title: 'EPT ITALY',
        subtitle: 'Manage your team, dominate the league',
        cta: 'Get Started',
        features: {
          clubs: 'Create & Manage Clubs',
          clubsDesc: 'Build your dream team with custom logos and colors',
          market: 'Transfer Market',
          marketDesc: 'Buy, sell, and loan players with virtual coins',
          matches: 'Live Match Reports',
          matchesDesc: 'Track goals, assists, and cards in real-time',
          stats: 'Complete Statistics',
          statsDesc: 'Standings, top scorers, and player stats',
        },
      },
      // Auth
      auth: {
        email: 'Email',
        password: 'Password',
        name: 'Full Name',
        loginTitle: 'Welcome Back',
        registerTitle: 'Join the League',
        loginBtn: 'Sign In',
        registerBtn: 'Create Account',
        googleBtn: 'Continue with Google',
        noAccount: "Don't have an account?",
        hasAccount: 'Already have an account?',
        completeProfile: 'Complete Your Profile',
        gamertag: 'Gamertag',
        birthDate: 'Date of Birth',
        phone: 'Phone Number',
        completeBtn: 'Complete Profile',
        saving: 'Saving...',
        profileInfo: 'Enter your details to start playing',
      },
      // Dashboard
      dashboard: {
        welcome: 'Welcome back',
        yourClub: 'Your Club',
        coins: 'Coins',
        nextMatch: 'Next Match',
        marketAlerts: 'Market Alerts',
        recentActivity: 'Recent Activity',
        noClub: 'You don\'t have a club yet',
        createClub: 'Create Club',
      },
      // Club
      club: {
        roster: 'Roster',
        settings: 'Settings',
        invite: 'Invite Player',
        name: 'Club Name',
        colors: 'Team Colors',
        logo: 'Club Logo',
        uploadLogo: 'Upload Logo',
        players: 'Players',
        position: 'Position',
        number: 'Number',
        value: 'Value',
        salary: 'Salary',
        forSale: 'For Sale',
        addPlayer: 'Add Player',
      },
      // Market
      market: {
        title: 'Transfer Market',
        available: 'Available Players',
        myOffers: 'My Offers',
        received: 'Received Offers',
        history: 'Transfer History',
        makeOffer: 'Make Offer',
        offerAmount: 'Offer Amount',
        offerType: 'Offer Type',
        purchase: 'Purchase',
        loan: 'Loan',
        accept: 'Accept',
        reject: 'Reject',
        pending: 'Pending',
        accepted: 'Accepted',
        rejected: 'Rejected',
      },
      // Matches
      matches: {
        title: 'Matches',
        upcoming: 'Upcoming',
        completed: 'Completed',
        submitReport: 'Submit Report',
        homeScore: 'Home Score',
        awayScore: 'Away Score',
        events: 'Match Events',
        goal: 'Goal',
        assist: 'Assist',
        yellowCard: 'Yellow Card',
        redCard: 'Red Card',
        cleanSheet: 'Clean Sheet',
        minute: 'Minute',
        addEvent: 'Add Event',
      },
      // Championship
      championship: {
        title: 'Championship',
        standings: 'Standings',
        topScorers: 'Top Scorers',
        topAssists: 'Top Assists',
        fixtures: 'Fixtures',
        join: 'Join Championship',
        start: 'Start Championship',
        team: 'Team',
        played: 'P',
        won: 'W',
        drawn: 'D',
        lost: 'L',
        gf: 'GF',
        ga: 'GA',
        gd: 'GD',
        points: 'Pts',
      },
      // Admin
      admin: {
        title: 'Admin Panel',
        users: 'Users',
        championships: 'Championships',
        coins: 'Manage Coins',
        createChampionship: 'Create Championship',
        modifyCoins: 'Modify Coins',
        amount: 'Amount',
        reason: 'Reason',
        ban: 'Ban User',
        unban: 'Unban User',
        makeAdmin: 'Make Admin',
        seedData: 'Create Demo Data',
      },
      // Common
      common: {
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        view: 'View',
        loading: 'Loading...',
        error: 'Error',
        success: 'Success',
        noData: 'No data available',
        search: 'Search',
        filter: 'Filter',
        all: 'All',
      },
      // Notifications
      notifications: {
        title: 'Notifications',
        markRead: 'Mark as read',
        markAllRead: 'Mark all as read',
        noNotifications: 'No notifications',
      },
      // Positions
      positions: {
        GK: 'Goalkeeper',
        DEF: 'Defender',
        MID: 'Midfielder',
        FWD: 'Forward',
      },
    },
  },
  it: {
    translation: {
      // Navigation
      nav: {
        dashboard: 'Dashboard',
        club: 'Il Mio Club',
        market: 'Mercato',
        matches: 'Partite',
        championship: 'Campionato',
        admin: 'Pannello Admin',
        superAdmin: 'Super Admin',
        profile: 'Profilo',
        logout: 'Esci',
        login: 'Accedi',
        register: 'Registrati',
      },
      // Landing
      landing: {
        title: 'EPT ITALY',
        subtitle: 'Gestisci la tua squadra, domina il campionato',
        cta: 'Registrati Ora',
        features: {
          clubs: 'Crea e Gestisci Club',
          clubsDesc: 'Costruisci la tua squadra ideale con logo e colori personalizzati',
          market: 'Mercato Trasferimenti',
          marketDesc: 'Compra, vendi e presta giocatori con coins virtuali',
          matches: 'Report Partite Live',
          matchesDesc: 'Traccia gol, assist e cartellini in tempo reale',
          stats: 'Statistiche Complete',
          statsDesc: 'Classifiche, capocannonieri e statistiche giocatori',
        },
      },
      // Auth
      auth: {
        email: 'Email',
        password: 'Password',
        name: 'Nome Completo',
        loginTitle: 'Bentornato',
        registerTitle: 'Unisciti alla Lega',
        loginBtn: 'Accedi',
        registerBtn: 'Crea Account',
        googleBtn: 'Continua con Google',
        noAccount: 'Non hai un account?',
        hasAccount: 'Hai già un account?',
        completeProfile: 'Completa il Profilo',
        gamertag: 'Gamertag',
        birthDate: 'Data di Nascita',
        phone: 'Numero di Telefono',
        completeBtn: 'Completa Profilo',
        saving: 'Salvataggio...',
        profileInfo: 'Inserisci i tuoi dati per iniziare a giocare',
      },
      // Dashboard
      dashboard: {
        welcome: 'Bentornato',
        yourClub: 'Il Tuo Club',
        coins: 'Monete',
        players: 'Giocatori',
        rank: 'Posizione',
        nextMatch: 'Prossima Partita',
        marketAlerts: 'Avvisi Mercato',
        recentActivity: 'Attività Recente',
        noClub: 'Non hai ancora un club',
        createClub: 'Crea Club',
      },
      // Club
      club: {
        roster: 'Rosa',
        settings: 'Impostazioni',
        invite: 'Invita Giocatore',
        name: 'Nome Club',
        colors: 'Colori Squadra',
        logo: 'Logo Club',
        uploadLogo: 'Carica Logo',
        players: 'Giocatori',
        position: 'Posizione',
        number: 'Numero',
        value: 'Valore',
        salary: 'Stipendio',
        forSale: 'In Vendita',
        addPlayer: 'Aggiungi Giocatore',
      },
      // Market
      market: {
        title: 'Mercato Trasferimenti',
        available: 'Giocatori Disponibili',
        myOffers: 'Le Mie Offerte',
        received: 'Offerte Ricevute',
        history: 'Storico Trasferimenti',
        makeOffer: 'Fai Offerta',
        offerAmount: 'Importo Offerta',
        offerType: 'Tipo Offerta',
        purchase: 'Acquisto',
        loan: 'Prestito',
        accept: 'Accetta',
        reject: 'Rifiuta',
        pending: 'In Attesa',
        accepted: 'Accettata',
        rejected: 'Rifiutata',
      },
      // Matches
      matches: {
        title: 'Partite',
        upcoming: 'In Programma',
        completed: 'Completate',
        submitReport: 'Invia Report',
        homeScore: 'Gol Casa',
        awayScore: 'Gol Trasferta',
        events: 'Eventi Partita',
        goal: 'Gol',
        assist: 'Assist',
        yellowCard: 'Cartellino Giallo',
        redCard: 'Cartellino Rosso',
        cleanSheet: 'Clean Sheet',
        minute: 'Minuto',
        addEvent: 'Aggiungi Evento',
      },
      // Championship
      championship: {
        title: 'Campionato',
        standings: 'Classifica',
        topScorers: 'Capocannonieri',
        topAssists: 'Migliori Assistman',
        fixtures: 'Calendario',
        join: 'Iscriviti al Campionato',
        start: 'Avvia Campionato',
        team: 'Squadra',
        played: 'G',
        won: 'V',
        drawn: 'P',
        lost: 'S',
        gf: 'GF',
        ga: 'GS',
        gd: 'DR',
        points: 'Pt',
      },
      // Admin
      admin: {
        title: 'Pannello Admin',
        users: 'Utenti',
        championships: 'Campionati',
        coins: 'Gestisci Coins',
        createChampionship: 'Crea Campionato',
        modifyCoins: 'Modifica Coins',
        amount: 'Importo',
        reason: 'Motivo',
        ban: 'Banna Utente',
        unban: 'Sbanna Utente',
        makeAdmin: 'Rendi Admin',
        seedData: 'Crea Dati Demo',
      },
      // Common
      common: {
        save: 'Salva',
        cancel: 'Annulla',
        delete: 'Elimina',
        edit: 'Modifica',
        view: 'Visualizza',
        loading: 'Caricamento...',
        error: 'Errore',
        success: 'Successo',
        noData: 'Nessun dato disponibile',
        search: 'Cerca',
        filter: 'Filtra',
        all: 'Tutti',
      },
      // Notifications
      notifications: {
        title: 'Notifiche',
        markRead: 'Segna come letto',
        markAllRead: 'Segna tutto come letto',
        noNotifications: 'Nessuna notifica',
      },
      // Positions
      positions: {
        GK: 'Portiere',
        DEF: 'Difensore',
        MID: 'Centrocampista',
        FWD: 'Attaccante',
      },
    },
  },
  de: {
    translation: {
      nav: {
        dashboard: 'Dashboard',
        club: 'Mein Verein',
        market: 'Transfermarkt',
        matches: 'Spiele',
        championship: 'Meisterschaft',
        admin: 'Admin-Panel',
        superAdmin: 'Super Admin',
        profile: 'Profil',
        logout: 'Abmelden',
        login: 'Anmelden',
        register: 'Registrieren',
      },
      landing: {
        title: 'EPT ITALY',
        subtitle: 'Verwalte dein Team, dominiere die Liga',
        cta: 'Jetzt starten',
        features: {
          clubs: 'Vereine erstellen & verwalten',
          clubsDesc: 'Baue dein Traumteam mit eigenem Logo und Farben',
          market: 'Transfermarkt',
          marketDesc: 'Kaufe, verkaufe und leihe Spieler mit virtuellen M\u00fcnzen',
          matches: 'Live-Spielberichte',
          matchesDesc: 'Verfolge Tore, Vorlagen und Karten in Echtzeit',
          stats: 'Komplette Statistiken',
          statsDesc: 'Tabellen, Torsch\u00fctzenliste und Spielerstatistiken',
        },
      },
      auth: {
        email: 'E-Mail',
        password: 'Passwort',
        name: 'Vollst\u00e4ndiger Name',
        loginTitle: 'Willkommen zur\u00fcck',
        registerTitle: 'Tritt der Liga bei',
        loginBtn: 'Anmelden',
        registerBtn: 'Konto erstellen',
        googleBtn: 'Weiter mit Google',
        noAccount: 'Noch kein Konto?',
        hasAccount: 'Bereits ein Konto?',
        completeProfile: 'Profil vervollst\u00e4ndigen',
        gamertag: 'Gamertag',
        birthDate: 'Geburtsdatum',
        phone: 'Telefonnummer',
        completeBtn: 'Profil abschlie\u00dfen',
        saving: 'Speichern...',
        profileInfo: 'Gib deine Daten ein, um loszulegen',
      },
      dashboard: {
        welcome: 'Willkommen zur\u00fcck',
        yourClub: 'Dein Verein',
        coins: 'M\u00fcnzen',
        players: 'Spieler',
        rank: 'Platzierung',
        nextMatch: 'N\u00e4chstes Spiel',
        marketAlerts: 'Markt-Hinweise',
        recentActivity: 'Letzte Aktivit\u00e4t',
        noClub: 'Du hast noch keinen Verein',
        createClub: 'Verein erstellen',
      },
      club: {
        roster: 'Kader',
        settings: 'Einstellungen',
        invite: 'Spieler einladen',
        name: 'Vereinsname',
        colors: 'Vereinsfarben',
        logo: 'Vereinslogo',
        uploadLogo: 'Logo hochladen',
        players: 'Spieler',
        position: 'Position',
        number: 'Nummer',
        value: 'Wert',
        salary: 'Gehalt',
        forSale: 'Zum Verkauf',
        addPlayer: 'Spieler hinzuf\u00fcgen',
      },
      market: {
        title: 'Transfermarkt',
        available: 'Verf\u00fcgbare Spieler',
        myOffers: 'Meine Angebote',
        received: 'Erhaltene Angebote',
        history: 'Transfer\u00fcbersicht',
        makeOffer: 'Angebot machen',
        offerAmount: 'Angebotsbetrag',
        offerType: 'Angebotsart',
        purchase: 'Kauf',
        loan: 'Leihe',
        accept: 'Annehmen',
        reject: 'Ablehnen',
        pending: 'Ausstehend',
        accepted: 'Angenommen',
        rejected: 'Abgelehnt',
      },
      matches: {
        title: 'Spiele',
        upcoming: 'Anstehend',
        completed: 'Abgeschlossen',
        submitReport: 'Bericht einreichen',
        homeScore: 'Heim-Tore',
        awayScore: 'Ausw\u00e4rts-Tore',
        events: 'Spielereignisse',
        goal: 'Tor',
        assist: 'Vorlage',
        yellowCard: 'Gelbe Karte',
        redCard: 'Rote Karte',
        cleanSheet: 'Ohne Gegentor',
        minute: 'Minute',
        addEvent: 'Ereignis hinzuf\u00fcgen',
      },
      championship: {
        title: 'Meisterschaft',
        standings: 'Tabelle',
        topScorers: 'Torsch\u00fctzenliste',
        topAssists: 'Beste Vorlagengeber',
        fixtures: 'Spielplan',
        join: 'Meisterschaft beitreten',
        start: 'Meisterschaft starten',
        team: 'Mannschaft',
        played: 'Sp',
        won: 'S',
        drawn: 'U',
        lost: 'N',
        gf: 'T+',
        ga: 'T-',
        gd: 'TD',
        points: 'Pkt',
      },
      admin: {
        title: 'Admin-Panel',
        users: 'Benutzer',
        championships: 'Meisterschaften',
        coins: 'M\u00fcnzen verwalten',
        createChampionship: 'Meisterschaft erstellen',
        modifyCoins: 'M\u00fcnzen \u00e4ndern',
        amount: 'Betrag',
        reason: 'Grund',
        ban: 'Benutzer sperren',
        unban: 'Benutzer entsperren',
        makeAdmin: 'Zum Admin machen',
        seedData: 'Demo-Daten erstellen',
      },
      common: {
        save: 'Speichern',
        cancel: 'Abbrechen',
        delete: 'L\u00f6schen',
        edit: 'Bearbeiten',
        view: 'Anzeigen',
        loading: 'Laden...',
        error: 'Fehler',
        success: 'Erfolg',
        noData: 'Keine Daten verf\u00fcgbar',
        search: 'Suchen',
        filter: 'Filtern',
        all: 'Alle',
      },
      notifications: {
        title: 'Benachrichtigungen',
        markRead: 'Als gelesen markieren',
        markAllRead: 'Alle als gelesen markieren',
        noNotifications: 'Keine Benachrichtigungen',
      },
      positions: {
        GK: 'Torwart',
        DEF: 'Verteidiger',
        MID: 'Mittelfeldspieler',
        FWD: 'St\u00fcrmer',
      },
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'it',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
